module.exports = __webpack_public_path__ + "static/media/releaseNotes.68771cfa.md";